<template>
  <div>
    <div>
      <button class="d-none" data-toggle="modal" data-target="#GameModal" ref="openTournamentGameModal"></button>
      <div class="modal fade" id="GameModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog product-cart-modal" role="document">
          <div class="modal-content d-block">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Switch Game</h5>
              <button type="button" class="close cursor-pointer" data-dismiss="modal" aria-label="Close">
                <img src="../../../assets/Svg/close.svg" alt="">
              </button>
            </div>

            <div class="modal-body overflow-auto">
              <div v-if="showLoader === 1" class="card-event mt-3">
                <content-placeholders :rounded="true">
                  <content-placeholders-img />
                  <content-placeholders-heading />
                </content-placeholders>

                <br />

                <content-placeholders :rounded="true">
                  <content-placeholders-img />
                  <content-placeholders-heading />
                </content-placeholders>
              </div>
              <div v-else-if="gameList.length === 0 && showLoader === 0">
                <div class="no-chat-text">
                  <p>No game is scheduled yet</p>
                </div>
              </div>
              <div v-if="gameList.length > 0 && showLoader === 0" class="live-league-wrap">
                <div v-for="(schedule, index) in gameList" :key="index">
                  <div class="cursor-pointer" data-dismiss="modal" @click="callSingleBoxModal(schedule)">

                    <div class="schedule-info flex-column flex-md-row" style="gap: 5px;" :class="{
                      'last-schedule-info': index === gameList.length - 1,
                    }">
                      <div class="row no-gutters align-items-center w-100 single-event-side-game">
                        <div class="col-12 col-lg-3 left-side-portion">
                          <div class="start-time">{{ schedule.start_time }}</div>
                          <div>{{ formatDate(schedule.start_date) }}</div>
                          <div class="content" v-if="schedule.umpire">Umpire: {{ schedule.umpire?.name }}</div>
                        </div>
                        <div
                          class="col-12 col-lg-6 d-flex align-items-center flex-wrap flex-column flex-md-row"
                          style="gap: 10px;">
                          <div class="row no-gutters w-100 align-items-center">
                            <div class="col-12 col-lg-4 center-content">
                              <div v-if="schedule.game_scores?.length != 0">
                                <div class="opponent-tag" v-if="
                                  schedule.game_scores?.some((team) => team.team_type === 1)
                                ">
                                  <h6
                                    :class="{
                                      'winner-text':
                                        schedule.status === 2 &&
                                        calculateGameScores(schedule).visitRuns >
                                          calculateGameScores(schedule).homeRuns,
                                      'loser-text':
                                        schedule.status === 2 &&
                                        calculateGameScores(schedule).visitRuns <
                                          calculateGameScores(schedule).homeRuns,
                                    }"
                                  >
                                    #{{
                                      schedule.game_scores?.find(
                                        (team) => team.team_type === 1
                                      )?.teams.team_sr_no
                                    }}:
                                    {{
                                      schedule.game_scores?.find(
                                        (team) => team.team_type === 1
                                      )?.team.team_name
                                    }}
                                  </h6>
                                  <div class="custom-avatar" 
                                      v-if="schedule.game_scores?.find(team => team.team_type === 1)?.team.team_avatar == null"
                                      :style="{ backgroundColor: getRandomColor() }">
                                      {{ getInitials(schedule.game_scores?.find(team => team.team_type === 1)?.team.team_name) }}
                                  </div>
                                  <div class="team-image" v-else>
                                    <div class="users-notification" v-if="imgLoader == 1">
                                      <img src="../../../assets/loader.gif" alt="" />
                                    </div>
                                    <img @load="onImageLoad" v-if="schedule.game_scores?.find(
                                      (team) => team.team_type === 1
                                    )?.team.team_avatar == null" :src="team_image" alt="" />
                                    <img @load="onImageLoad" v-if="schedule.game_scores?.find(
                                      (team) => team.team_type === 1
                                    )?.team.team_avatar != null" :src="url + schedule.game_scores?.find(
                                      (team) => team.team_type === 1
                                    )?.team.team_avatar" alt="" />
                                  </div>
                                  <p class="score-text"
                                    :class="{
                                      'loser-text':
                                        schedule.status === 2 &&
                                        calculateGameScores(schedule).visitRuns <
                                          calculateGameScores(schedule).homeRuns,
                                      'winner-text':
                                        schedule.status === 2 &&
                                        calculateGameScores(schedule).visitRuns >
                                          calculateGameScores(schedule).homeRuns
                                    }"
                                    v-if="calculateGameScores(schedule).homeRuns != 0 || calculateGameScores(schedule).visitRuns != 0">
                                    {{ calculateGameScores(schedule).visitRuns }}</p>
                                  <img :src="arrow_left" class="arrow-image" alt="arrow-left" v-if="
                                    schedule.status === 1 &&
                                    schedule.game_scores &&
                                    schedule.game_scores?.find(
                                      (team) =>

                                        team.team_type == 1 &&
                                        team.batting_flag == 1
                                    )
                                  " />
                                  <img :src="cup" alt="cup"
                                    v-if="schedule.status === 2 && calculateGameScores(schedule).visitRuns > calculateGameScores(schedule).homeRuns" />
                                </div>
                              </div>
                              <div class="opponent-data" v-else>
                                <h6>
                                  #{{
                                    schedule.team_one?.team_sr_no
                                  }}:
                                  {{
                                    schedule.team_one?.team_data?.team_name
                                  }}
                                </h6>
                                <div class="custom-avatar" 
                                  v-if="schedule.team_one?.team_data?.team_avatar == null"
                                  :style="{ backgroundColor: getRandomColor() }">
                                  {{ getInitials(schedule.team_one?.team_data?.team_name) }}
                                </div>
                                <div class="team-image" v-else>
                                  <div class="users-notification" v-if="imgLoader == 1">
                                    <img src="../../../assets/loader.gif" alt="" />
                                  </div>
                                  <img @load="onImageLoad" v-if="schedule.team_one?.team_data?.team_avatar == null"
                                    :src="team_image" alt="" />
                                  <img @load="onImageLoad" v-if="schedule.team_one?.team_data?.team_avatar != null"
                                    :src="url + schedule.team_one?.team_data?.team_avatar" alt="" />
                                </div>
                                <span>-</span>
                              </div>
                            </div>

                            <div class="col-12 col-lg-4 center-content">
                              <span>{{ schedule?.field?.field_name }}</span>
                              <div class="begin-btn" v-if="schedule.game_scores.length == 0">Yet to Begin</div>
                              <div class="begin-btn inning-btn"
                                v-if="schedule.game_scores.length != 0 && schedule.status === 1 && schedule.game_delayed == 0">
                                Inning:
                                {{ schedule.game_scores[0].end_inning_flag }}</div>
                              <div class="begin-btn final-btn"
                                v-if="schedule.game_scores.length != 0 && schedule.status === 2">
                                Final</div>
                              <div class="begin-btn delayed-btn"
                                v-if="schedule.game_scores.length != 0 && schedule.status === 1 && schedule.game_delayed == 1">
                                Delayed</div>
                              <span>{{ schedule.game_name }}</span>
                            </div>

                            <div class=" col-12 col-lg-4 d-flex flex-row flex-wrap justify-content-center right-section-popup">
                              <div v-if="schedule.game_scores?.length != 0">
                                <div class="opponent-tag" v-if="
                                  schedule.game_scores?.some((team) => team.team_type === 2)
                                ">
                                  <img :src="arrow_left" class="arrow-image" alt="arrow-left" v-if="
                                    schedule.status === 1 &&
                                    schedule.game_scores &&
                                    schedule.game_scores?.find(
                                      (team) =>

                                        team.team_type == 2 &&
                                        team.batting_flag == 1
                                    )
                                  " />
                                  <img :src="cup" alt="cup"
                                    v-if="schedule.status === 2 && calculateGameScores(schedule).homeRuns > calculateGameScores(schedule).visitRuns" />
                                  <p class="score-text win-data-two flex-row align-items-center"
                                    :class="{
                                      'loser-text':
                                        schedule.status === 2 &&
                                        calculateGameScores(schedule).homeRuns <
                                          calculateGameScores(schedule).visitRuns,
                                      'winner-text':
                                        schedule.status === 2 &&
                                        calculateGameScores(schedule).homeRuns >
                                          calculateGameScores(schedule).visitRuns
                                    }" 
                                  v-if="calculateGameScores(schedule).homeRuns != 0 || calculateGameScores(schedule).visitRuns != 0"
                                  style="gap: 5px">
                                    {{ calculateGameScores(schedule).homeRuns }}
                                  </p>
                                  <div class="custom-avatar" 
                                    v-if="schedule.game_scores?.find(team => team.team_type === 2)?.team.team_avatar == null"
                                    :style="{ backgroundColor: getRandomColor() }">
                                    {{ getInitials(schedule.game_scores?.find(team => team.team_type === 2)?.team.team_name) }}
                                  </div>
                                  <div class="team-image" v-else>
                                    <div class="users-notification" v-if="imgLoader == 1">
                                      <img src="../../../assets/loader.gif" alt="" />
                                    </div>
                                    <img @load="onImageLoad" v-if="schedule.game_scores?.find(
                                      (team) => team.team_type === 2
                                    )?.team.team_avatar == null" :src="team_image" alt="" />
                                    <img @load="onImageLoad" v-if="schedule.game_scores?.find(
                                      (team) => team.team_type === 2
                                    )?.team.team_avatar != null" :src="url + schedule.game_scores?.find(
                                      (team) => team.team_type === 2
                                    )?.team.team_avatar" alt="" />
                                  </div>
                                  <h6
                                    :class="{
                                      'winner-text':
                                        schedule.status === 2 &&
                                        calculateGameScores(schedule).homeRuns >
                                          calculateGameScores(schedule).visitRuns,
                                      'loser-text':
                                        schedule.status === 2 &&
                                        calculateGameScores(schedule).homeRuns <
                                          calculateGameScores(schedule).visitRuns,
                                    }"
                                  >
                                    #{{
                                      schedule.game_scores?.find(
                                        (team) => team.team_type === 2
                                      )?.teams.team_sr_no
                                    }}:
                                    {{
                                      schedule.game_scores?.find(
                                        (team) => team.team_type === 2
                                      )?.team.team_name
                                    }}
                                  </h6>
                                </div>
                              </div>
                              <div class="opponent-data" v-else>
                                <span>-</span>
                                <div class="custom-avatar" 
                                  v-if="schedule.team_two?.team_data?.team_avatar == null"
                                  :style="{ backgroundColor: getRandomColor() }">
                                  {{ getInitials(schedule.team_two?.team_data?.team_name) }}
                                </div>
                                <div class="team-image" v-else>
                                  <div class="users-notification" v-if="imgLoader == 1">
                                    <img src="../../../assets/loader.gif" alt="" />
                                  </div>
                                  <img @load="onImageLoad" v-if="schedule.team_two?.team_data?.team_avatar == null"
                                    :src="team_image" alt="" />
                                  <img @load="onImageLoad" v-if="schedule.team_two?.team_data?.team_avatar != null"
                                    :src="url + schedule.team_two?.team_data?.team_avatar" alt="" />
                                </div>
                                <h6>
                                  #{{
                                    schedule.team_two?.team_sr_no
                                  }}:
                                  {{
                                    schedule.team_two?.team_data?.team_name
                                  }}
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-lg-3">
                          <h6 class="text-right">
                            {{ schedule.event.eventName }}
                          </h6>
                          <h6 class="text-right">{{ schedule?.tournament?.tournamentName }}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
import axios from "axios";
export default {
  components: {},
  name: "TournamentGameListModal",

  data() {
    return {
      url: this.$groupAvatarStorageURL,
      imgLoader: 1,
      gameList: [], // Dummy game list
      singleGame: {},
      showLoader: 1,
      page: 1,
      lastPage: 1,
      totalGames: null,
      arrow_left: require("../../../assets/Svg/arrow-left.svg"),
      cup: require("../../../assets/Svg/cup.svg"),
      team_image: require("../../../assets/Svg/people.svg"),
    };
  },

  methods: {
    formatDate(date) {
      return new Intl.DateTimeFormat("en-US", {
        weekday: "short",
        month: "short",
        day: "2-digit",
        year: "numeric"
      }).format(new Date(date));
    },
    getInitials(name) {
      return name ? name.charAt(0).toUpperCase() : "?";
    },
    getRandomColor() {
      const colors = [
        "#FCE4EC",
        "#E3F2FD",
        "#F1F8E9",
        "#FFF8E1",
        "#EDE7F6",
        "#FFEBEE",
        "#F9FBE7",
        "#FFF3E0",
        "#ECEFF1",
        "#FFECB3",
      ];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    onImageLoad() {
      this.imgLoader = 0;
    },
    async getGames() {
    
      this.showLoader = 1;

      var formData = new FormData();
      formData.append("tournament_guid", this.singleGame.tournament.guid);
      await axios
        .post(
          process.env.VUE_APP_API_URL + "tournaments/getTournamentGames",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          this.gameList = this.gameList.concat(response.data.data);
          this.lastPage = response.data.data.last_page;
          this.totalGames = response.data.data.total;

          this.showLoader = 0;
        });
    },
    calculateGameScores(gameItem) {
      if (!gameItem.game_scores || gameItem.game_scores.length === 0) {
        return { homeRuns: 0, visitRuns: 0 };
      }

      let homeRuns = 0;
      let visitRuns = 0;

      // Process each team's scores
      gameItem.game_scores.forEach((gameS) => {
        if (gameS.team_type === 1) { // Visiting team
          gameS.game_innings.forEach((inning) => {
            if (inning.inning_type === 2 && inning.score !== null) { // Only count runs (inning_type 2)
              visitRuns += parseInt(inning.score);
            }
          });
        } else if (gameS.team_type === 2) { // Home team
          gameS.game_innings.forEach((inning) => {
            if (inning.inning_type === 2 && inning.score !== null) { // Only count runs (inning_type 2)
              homeRuns += parseInt(inning.score);
            }
          });
        }
      });

      return { homeRuns, visitRuns };
    },
    openParkGoogleMap(item) {
      let urlSuffix;
      if (item["lat"] && item["lng"]) {
        const strlatLng = item["lat"] + "," + item["lng"];
        urlSuffix = strlatLng;
      } else {
        urlSuffix = encodeURIComponent(
          item["address"] + ", " + item["city"] + ", " + item["zipCode"]
        );
      }
      window.open(
        "https://www.google.com/maps/search/?api=1&query=" + urlSuffix,
        "_blank"
      );
    },
    formatStartTime(startDate, startTime) {
      // If startDate or startTime is not provided, return an empty string
      if (!startDate || !startTime) return "";

      // Split startTime into hours, minutes, and AM/PM
      const [hours, minutes] = startTime
        .match(/(\d+):(\d+) ([AaPp][Mm])/)
        .slice(1);

      // Split startDate into year, month, and day
      const [year, month, day] = startDate.split("-").map(Number);

      // Create a new Date object using the components
      const date = new Date(
        year,
        month - 1,
        day,
        parseInt(hours),
        parseInt(minutes)
      );

      // Format the date using the specified format
      const formattedDate = date.toLocaleString("en-US", {
        weekday: "short",
        month: "short",
        day: "2-digit",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });

      return formattedDate;
    },
    callSingleBoxModal(schedule) {
      var combineUrl = `${schedule.guid}`;
      this.$router.push({
        name: "TournamentScores",
        params: { guid: combineUrl },
      });
      this.$root.$emit("showSingleBoxScoreTournamentForGameSwitch");
    },
  },
 mounted() {

  // $(window).on("popstate", function() {
    //   $(".modal-backdrop").remove();
    //   $("body").removeClass("modal-open");
    // });
    this.$store.commit("setErrors", {});
    
    // Create reference to handler for cleanup
    this.modalHandler = (game) => {
      this.singleGame = game;
      this.gameList = [];
      this.getGames();
      const elem = this.$refs.openTournamentGameModal;
      if (elem) elem.click();
    };

    // Attach listener
    this.$root.$on("openTournamentGamesDataModal", this.modalHandler);
  },
  
  beforeDestroy() {
    // Clean up event listener
    this.$root.$off("openTournamentGamesDataModal", this.modalHandler);
  }
};
</script>